import 'react-image-crop/dist/ReactCrop.css';

import { ControlType, FetchStatus } from '../../../../base/types';
import { ErrorMessage, Spinner } from '../../../../widgets';
import { WebcamImageProperties, useWebcamImageProperties } from './WebcamImageProperties';

import { DraftWebcamImageComponent } from './DraftWebcamImageComponent';
import { FC } from 'react';
import { IControlAttributes } from '../../../../base/models';
import { Registry } from '../../../../base/register';
import { WebcamImage } from './WebcamImage';

export const WebcamImageComponent: FC<IControlAttributes> = ({
  className, props
}) => {
  const { status, properties, error } = useWebcamImageProperties(props);

  switch (status) {
    case FetchStatus.Idle: return <></>
    case FetchStatus.Loading: return <Spinner show={true} />
    case FetchStatus.Error: return <ErrorMessage message={error} />
  }

  return <WebcamImage {...properties} className={className} />;
};

Registry.addControl({
  id: "14d2c49c-04a8-45d9-8257-54a4a1e0352d",
  name: "Webcam Image",
  type: ControlType.WebcamImage,
  properties: WebcamImageProperties,
  component: WebcamImageComponent,
  draftComponent: DraftWebcamImageComponent
})